import DragDropBlockSelector from './dragDropBlockSelector/dragDropBlockSelector';
import DragDropBlock from './dragDropBlock/dragDropBlock';
import colorPicker from '@caohenghu/vue-colorpicker';
import ImageManager from '@/components/campaign/contentBuilder/imageUpload/imageUpload';
import ProductSelectionPopup from '@/components/productSelectionPopup/productSelectionPopup';
import draggable from 'vuedraggable';
import DynamicUserProperty from '@/components/dynamicUserFilterComponent/dynamicUserFilter';
import savedBlocksModule from '@/services/savedBlocks';
import companyModule from '@/services/company';
import couponModule from '@/services/coupon';
import html2canvas from 'html2canvas';
import productSetsModule from '@/services/productSets';
const _ = require('lodash');
import TextStyleBuilder from '@/components/campaign/contentBuilder/styleBuilder/text/textStyleBuilder';
import CouponStyleBuilder from '@/components/campaign/contentBuilder/styleBuilder/coupon/couponStyleBuilder';
import MinimalTextStyleBuilder from '@/components/campaign/contentBuilder/styleBuilder/minimalText/minimalTextStyleBuilder';
import ButtonStyleBuilder from '@/components/campaign/contentBuilder/styleBuilder/button/buttonStyleBuilder';
import EmailFontStyleBuilder from '@/components/campaign/contentBuilder/styleBuilder/emailFont/emailFontBuilder';
import CampaignMixin from '@/mixins/campaignMixin';
import imageMgtService from '@/services/imageMgtService';

import MceTextEditor from '@/components/mceTextEditor/mceTextEditor';

export default {
  name: 'dragDropEditor',
  props: {
    isJourneyCampaign: {
      type: Boolean,
      required: true
    }
  },
  mixins: [CampaignMixin],
  components: {
    DragDropBlockSelector,
    colorPicker,
    draggable,
    ImageManager,
    DragDropBlock,
    DynamicUserProperty,
    ProductSelectionPopup,
    TextStyleBuilder,
    CouponStyleBuilder,
    MinimalTextStyleBuilder,
    ButtonStyleBuilder,
    EmailFontStyleBuilder,
    MceTextEditor
  },
  data() {
    return {
      drag: false,
      blockList: [],
      selectedLeftSideTab: 'general',
      selectedLeftSiteSettingsScope: 'row',
      selectedBlock: null,
      selectedRow: null,
      customFontsList: [],

      // Default Mail Settings
      selectedMailOption: 'general',
      mailOptions: {
        mailMaxWidth: '100%',
        background: '#ffffff',
        textStyle: {
          text: { label: 'Text', selector: '.mailBody .blockSection', textColor: '#222222', alignment: 'left', fontFamily: { label: 'Helvetica Neue', value: '"Helvetica Neue", Arial' }, fontSize: 16, fontWeight: 'normal', lineHeight: 130, letterSpacing: 0 },
          h1: { label: 'Heading 1', selector: '.mailBody .blockSection h1, .mailBody .blockSection h1 span', textColor: '#222222', alignment: 'left', fontFamily: { label: 'Helvetica Neue', value: '"Helvetica Neue", Arial' }, fontSize: 40, fontWeight: 'normal', marginBottom: 10, lineHeight: 110, letterSpacing: 0 },
          h2: { label: 'Heading 2', selector: '.mailBody .blockSection h2, .mailBody .blockSection h2 span', textColor: '#222222', alignment: 'left', fontFamily: { label: 'Helvetica Neue', value: '"Helvetica Neue", Arial' }, fontSize: 32, fontWeight: 'bold', marginBottom: 10, lineHeight: 100, letterSpacing: 0 },
          h3: { label: 'Heading 3', selector: '.mailBody .blockSection h3, .mailBody .blockSection h3 span', textColor: '#222222', alignment: 'left', fontFamily: { label: 'Helvetica Neue', value: '"Helvetica Neue", Arial' }, fontSize: 24, fontWeight: 'bold', marginBottom: 7, lineHeight: 110, letterSpacing: 0 },
          h4: { label: 'Heading 4', selector: '.mailBody .blockSection h4, .mailBody .blockSection h4 span', textColor: '#222222', alignment: 'left', fontFamily: { label: 'Helvetica Neue', value: '"Helvetica Neue", Arial' }, fontSize: 18, fontWeight: 'normal', marginBottom: 4, lineHeight: 110, letterSpacing: 0 }
        },
        textStyleOutput: ``,
        widthInfo: {
          type: 'custom',
          width: 750
        }
      },
      brandInfo: null,

      // Drag drop variables
      newBlockDragDropInProcess: false,
      currentDragBlockId: null,
      currentDragBlockHintSide: 'top',

      // Popover Flags
      ckEditorDynmicPopover: false,
      imageDynmicUserPopver: false,
      productSelectorPopver: false,
      productReviewPopover: false,
      imageLinkDynmicUserPopver: false,
      buttonLinkDynmicUserPopver: false,

      // Icon Images Editor
      imageListDrag: false,
      imageListBlockSettings: {
        predefined: [
          {
            id: 'custom',
            title: 'Custom Icon',
            image: '',
            url: ''
          },
          {
            id: 'facebook',
            title: 'Facebook',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/facebook.png',
            url: ''
          },
          {
            id: 'instagram',
            title: 'Instagram',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/instagram.png',
            url: ''
          },
          {
            id: 'twitter',
            title: 'Twitter',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/twitter.png',
            url: ''
          },
          {
            id: 'linkedin',
            title: 'LinkedIn',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/linkedin.png',
            url: ''
          },
          {
            id: 'pinterest',
            title: 'Pinterest',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/pinterest.png',
            url: ''
          },
          {
            id: 'android',
            title: 'Android',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/android.png',
            url: ''
          },
          {
            id: 'apple',
            title: 'Apple',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/apple.png',
            url: ''
          },
          {
            id: 'email',
            title: 'Email',
            image: 'https://static.growlytics.in/drag-drop-editor-assets/email.png',
            url: ''
          }
        ]
      },

      // Product Sets Variables.
      productCollectionList: [],
      selectedCollectionToInclude: null,
      selectedCollectionToExclude: null,
      productDisplayPriorityList: {
        popular: { title: 'Popular Products First', description: 'Products are ordered in descending popularity — those that are purchased most frequently in the past 90 days are recommended first.' },
        trending: { title: 'Trending Products First', description: 'Products are ordered not only by the frequency but also by the recency of their purchases. Under this option, a product purchased many times today will be ranked higher than a product that has not been purchased frequently in the last week.' },
        random: { title: 'Random', description: 'Products in the feed are randomly selected at recommendation time.' }
      },
      productDisplayPriorityEvents: {
        'Product Purchased': { title: 'Product Purchased', description: 'Product ordering will be done based on products purchased by customers.' },
        'Add To Cart': { title: 'Add To Cart', description: 'Product ordering will be done based on products added to cart by visitors.' },
        'Product Viewed': { title: 'Product Viewed', description: 'Product ordering will be done based on products viewed by visitors.' }
      },
      // Product Search Variables.
      productSearchedList: null,
      productSearchLoader: false,
      selectedProductToAdd: null,

      // Discount Block Variables
      couponList: null
    };
  },

  watch: {
    selectedBlock: function () {
      if (this.selectedBlock == null) {
        this.selectedLeftSideTab = 'general';
      }
    },
    'mailOptions.textStyle': {
      deep: true,
      handler() {
        this.prepareHtmlFontStyle();
      }
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    }
  },

  methods: {
    showBlockSelector(index, columnIndex, columnVerticalIndex) {
      this.$refs.blockSelector.showPopup(index, columnIndex, columnVerticalIndex);
    },

    // Called when according change on left side.
    onBlockSettingCollapseSectionChange() {
      if (!this.selectedBlock) return;

      if (this.selectedBlock.type == 'discount' || this.selectedBlock.type == 'email-footer') {
        let refName = this.selectedLeftSiteSettingsScope;
        if (this.$refs[refName]) this.$refs[refName].show();
      }
    },

    onAddSocialIcons(selectedIcon) {
      this.selectedBlock.content.iconList.push(JSON.parse(JSON.stringify(selectedIcon)));
    },

    addBlock(info) {
      Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
      };

      info.block = this.checkForRemovingRowPaddingFromOlderDivs(info.block);

      if (info.columnIndex === undefined && info.columnIndex == null) {
        this.blockList.insert(info.index, info.block);
        this.onBlockSelect(info.block, info.block, true);
      } else {
        this.blockList[info.index].content.columns[info.columnIndex].insert(info.columnVerticalIndex, info.block);
        this.onBlockSelect(info.block, this.blockList[info.index], true);
      }
    },

    removeBlock(index) {
      this.$confirm('Delete block?', 'Warning', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.blockList.splice(index, 1);
        requestAnimationFrame(() => {
          this.selectedBlock = null;
          this.$forceUpdate();
        });
      });
    },

    copyBlock(index) {
      let newCopy = JSON.parse(JSON.stringify(this.blockList[index]));
      newCopy.id = new Date().valueOf();
      newCopy.showDroppers = false;
      newCopy.showBlockDroppers = false;

      // Add new ids for sub columns as well
      if (newCopy.type.startsWith('columns')) {
        for (let i = 0; i < newCopy.content.columns.length; i++) {
          for (let j = 0; j < newCopy.content.columns[i].length; j++) {
            newCopy.content.columns[i][j].id = new Date().valueOf() + i.toString() + j.toString();
            newCopy.content.columns[i][j].showDroppers = false;
          }
        }
      }

      Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
      };

      this.blockList.insert(index, newCopy);
      this.successToast('Block copied.');
    },

    async saveBlockForLaterUse(index) {
      let block = this.blockList[index];
      this.showSaveBlockLoader = true;

      // Take input for block name
      let blockName = null;
      try {
        blockName = await this.$prompt('Enter Block Name', 'Save Block - To use it later', {
          confirmButtonText: 'Save Block',
          cancelButtonText: 'Cancel',
          inputPattern: /^(.){3,100}$/,
          inputErrorMessage: 'Block Name must be of 3 to 100 characters'
        });
        blockName = blockName.value;
      } catch (ex) {
        // Block Cancelled ignore
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: 'Saving Block (may take upto 10 seconds)',
        spinner: 'el-icon-loading',
        background: '#f5f7fad9'
      });

      // Take snapshot.
      setTimeout(() => {
        let blockId = 'email-block-' + block.id;
        console.log('before time is', new Date());

        html2canvas(document.getElementById(blockId), { useCORS: true }).then(async (canvas) => {
          console.log('Canvas After  time is', new Date());
          let imagedata = canvas.toDataURL('image/png');
          console.log('Url After  time is', new Date());

          let params = {
            name: blockName,
            image: imagedata,
            content: block
          };

          try {
            await savedBlocksModule.saveBlock(params, this);
            this.successToast('Blockd saved.');
            console.log('API After  time is', new Date());
            loading.close();
          } catch (err) {
            console.error(err);
            this.errorToast('Block save failed.');
            loading.close();
          }
        });
      }, 700);
    },

    removeBlockFromColumn(index, columnIndex, columnVerticalIndex) {
      let columnRowList = this.blockList[index].content.columns[columnIndex];
      columnRowList.splice(columnVerticalIndex, 1);
      requestAnimationFrame(() => {
        this.selectedBlock = null;
      });
    },

    copyBlockToColumn(index, columnIndex, columnVerticalIndex) {
      let newCopy = JSON.parse(JSON.stringify(this.blockList[index].content.columns[columnIndex][columnVerticalIndex]));
      newCopy.id = new Date().valueOf();
      newCopy.showDroppers = false;
      newCopy.showBlockDroppers = false;

      Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
      };

      this.blockList[index].content.columns[columnIndex].insert(columnVerticalIndex, newCopy);
      this.successToast('Block copied.');
    },

    onBlockSelect(block, row) {
      this.selectedBlock = block;
      this.selectedRow = row;
      this.selectedLeftSideTab = 'settings';
      if (this.selectedBlock.type.startsWith('column')) {
        this.selectedLeftSiteSettingsScope = 'row';
      } else {
        this.selectedLeftSiteSettingsScope = 'block';
      }

      if (this.selectedBlock.type == 'text') {
        if (this.$refs.mceEditor) {
          this.$refs.mceEditor.setContent(this.selectedBlock.content.html);
        }
      }

      // Check for prodcut sets, collection fetching
      else if (this.selectedBlock.type == 'product') {
        this.fetchProductCollections();
        requestAnimationFrame(() => {
          this.changeBlockConents();
        });
      }

      // Check for prodcut sets, collection fetching
      else if (this.selectedBlock.type == 'single-product') {
        requestAnimationFrame(() => {
          this.changeBlockConents();
        });
      }

      // Check for coupon fetching
      else if (this.selectedBlock.type == 'discount') {
        this.selectedLeftSiteSettingsScope = 'coupon-code';

        requestAnimationFrame(() => {
          this.fetchCouponList();
        });
      }

      // Check for coupon fetching
      else if (this.selectedBlock.type == 'custom-html') {
        this.selectedLeftSiteSettingsScope = 'custom-html';
      }
    },

    setColor(obj, property, args) {
      let color = args[0];
      obj[property] = this.RGBAToHexA(color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a).toUpperCase();
    },

    changeBlockConents(skipDataFetch) {
      let refName = 'block-' + this.selectedBlock.id;
      this.$refs[refName][0].changeBlockConents(skipDataFetch, this.selectedBlock);
    },

    onBlockEditorHtmlChange(data) {
      this.selectedBlock.content.html = data.data;
    },

    //#region   ----------- Start: Email Footer ---------------

    async onEmailFooterSocialIconColorchange(args) {
      console.log(`incoming args are`, args[0].hex);
      this.selectedBlock.content.socialLinks.iconColor = args[0].hex;

      // Change all colors
      let iconList = [];
      for (let i = 0; i < this.selectedBlock.content.socialLinks.list.length; i++) {
        iconList.push(this.selectedBlock.content.socialLinks.list[i].icon);
      }

      let response = await imageMgtService.svg2img({
        blockId: this.selectedBlock.id,
        iconList: iconList,
        color: this.selectedBlock.content.socialLinks.iconColor
      });

      for (let i = 0; i < this.selectedBlock.content.socialLinks.list.length; i++) {
        let iconType = this.selectedBlock.content.socialLinks.list[i].icon;
        if (response.data[iconType]) {
          this.selectedBlock.content.socialLinks.list[i].image = response.data[iconType];
        }
      }
      console.log('response came', response.data, this.selectedBlock.content.socialLinks.list);
    },

    async onEmailFooterSocialIconAdd(iconType) {
      let response = await imageMgtService.svg2img({
        blockId: this.selectedBlock.id,
        iconList: [iconType],
        color: this.selectedBlock.content.socialLinks.iconColor
      });

      let newSocialIcon = {
        icon: iconType,
        image: response.data[iconType],
        url: ''
      };
      this.selectedBlock.content.socialLinks.list.push(newSocialIcon);
    },

    //#endregion   ----------- End: Email Footer ---------------

    //#region   ----------- Start: Coupon ---------------

    async fetchCouponList() {
      try {
        if (this.couponList != null) return;
        let result = await couponModule.fetchCouponList({}, this);
        this.couponList = result.data.list;
      } catch (err) {
        console.error('Failed to fetch coupon list.', err);
        this.reportError(err);
      }
    },

    onSelectedCouponTypeChange() {
      if (this.selectedBlock.content.couponInfo.dynamic) {
        this.selectedBlock.content.expiryText.text = 'Expires on {coupon-expiry-time}';
      } else {
        this.selectedBlock.content.expiryText.text = this.selectedBlock.content.couponInfo.manual.expiryText;
      }
    },

    onSelectedCouponExpiryTimeTextChange() {
      this.selectedBlock.content.expiryText.text = this.selectedBlock.content.couponInfo.manual.expiryText;
    },

    //#endregion   ----------- End: Coupon ---------------

    //#region ----------- Start: Product Sets ---------------

    async fetchProductsWithKeyword(keyword) {
      try {
        this.productSearchLoader = true;
        let productList = await productSetsModule.searchProducts(keyword);
        this.productSearchedList = productList.data;
        this.productSearchLoader = false;
      } catch (err) {
        this.productSearchLoader = false;
        console.error('Failed to fetch product collectons.', err);
        this.reportError(err);
      }
    },

    onAddProductToList() {
      this.selectedBlock.content.productInfo.products.unshift(this.selectedProductToAdd);
      this.selectedProductToAdd = null;
      this.changeBlockConents();
    },

    onRemoveProductFromList(index) {
      this.selectedBlock.content.productInfo.products.splice(index, 1);
      this.changeBlockConents();
    },

    async fetchProductCollections() {
      try {
        if (!this.productCollectionList && this.productCollectionList.length > 0) return;
        let collectionList = await productSetsModule.getAllCollections(this);
        this.productCollectionList = collectionList.data;
      } catch (err) {
        console.error('Failed to fetch product collectons.', err);
        this.reportError(err);
      }
    },

    onIncludeCollection() {
      this.selectedBlock.content.productInfo.include.unshift(this.selectedCollectionToInclude);
      this.selectedCollectionToInclude = null;
      this.changeBlockConents();
    },

    onRemoveIncludedCollection(index) {
      this.selectedBlock.content.productInfo.include.splice(index, 1);
      this.changeBlockConents();
    },

    onExcludeCollection() {
      this.selectedBlock.content.productInfo.exclude.unshift(this.selectedCollectionToExclude);
      this.selectedCollectionToExclude = null;
    },

    //#endregion ----------- End: Product Sets ---------------

    //#region ----------- Start: Single Product ---------------

    showProductSelector() {
      this.$refs.productSelectionPopup.showPopup(true);
    },

    onProductSelectedFromPopup(selectedProduct) {
      if (selectedProduct) {
        this.selectedBlock.content.productInfo.id = selectedProduct.product_id;
        this.changeBlockConents(false);
      }
    },

    //#endregion ----------- End: Single Product ---------------

    //#region ----------- Start: Image Mgt---------------

    onImageUpload(block, propertyName, img) {
      block.content[propertyName] = img.url;
    },

    showImageuploader(refName) {
      this.$refs[refName].toggleVisiblity();
    },

    onUploadSocialIcon(index, img) {
      console.log('Image....', index, img);
      this.selectedBlock.content.iconList[index].image = img.url;
      // iconObject.image = img.url;
    },

    onUploadFooterLogo(img) {
      this.selectedBlock.content.logo.image = img.url;
    },

    showSocialIconUploader(refName) {
      this.$refs[refName][0].toggleVisiblity();
    },

    //#endregion ----------- End: Image Mgt---------------

    //#region ----------- Start: Dynamic User Property ---------------

    addDynamicPropToTextBlock(text) {
      if (text == 'unsubscribe') {
        this.$refs.mceEditor.setDynamicProp(text, true);
      } else {
        this.$refs.mceEditor.setDynamicProp(text, false);
      }
      this.ckEditorDynmicPopover = false;
    },

    addImageDynmicUserPopver(text) {
      let position = document.getElementById('inputImageLink').selectionStart;
      position = position ? position : 0;

      let link = this.selectedBlock.content.src ? this.selectedBlock.content.src : '';
      link = `${link.slice(0, position)}${text}${link.slice(position)}`;

      this.selectedBlock.content.src = link;
      this.imageDynmicUserPopver = false;
    },

    addImageLinkDynmicUserPopver(text) {
      let position = document.getElementById('inputImageClickLink').selectionStart;
      position = position ? position : 0;

      let link = this.selectedBlock.content.link ? this.selectedBlock.content.link : '';
      link = `${link.slice(0, position)}${text}${link.slice(position)}`;

      this.selectedBlock.content.link = link;
      this.imageLinkDynmicUserPopver = false;
    },

    addButtonLinkDynmicUserPopver(text) {
      let position = document.getElementById('inputButtonClickLink').selectionStart;
      position = position ? position : 0;

      let link = this.selectedBlock.content.link ? this.selectedBlock.content.link : '';
      link = `${link.slice(0, position)}${text}${link.slice(position)}`;

      this.selectedBlock.content.link = link;
      this.buttonLinkDynmicUserPopver = false;
    },

    addSingleProductLinkDynmicUserPopver(text) {
      let position = document.getElementById('inputSingleProductId').selectionStart;
      position = position ? position : 0;

      let link = this.selectedBlock.content.productInfo.id ? this.selectedBlock.content.productInfo.id : '';
      link = `${link.slice(0, position)}${text}${link.slice(position)}`;

      this.selectedBlock.content.productInfo.id = link;
      this.productSelectorPopver = false;
    },

    addProductReviewLinkDynmicUserPopver(text) {
      let position = document.getElementById('inputProductReviewOrderId').selectionStart;
      position = position ? position : 0;

      let link = this.selectedBlock.content.orderId ? this.selectedBlock.content.orderId : '';
      link = `${link.slice(0, position)}${text}${link.slice(position)}`;

      this.selectedBlock.content.orderId = link;
      this.productReviewPopover = false;
    },

    //#endregion ----------- End: Dynamic User Property ---------------

    //#region ----------- Parent Communication Methods---------------

    validateContent() {
      // Check for coupon
      let component = this;
      let blockTypeWiseCount = {};
      for (let i = 0; i < this.blockList.length; i++) {
        let block = this.blockList[i];

        // Update typewise count.
        if (!blockTypeWiseCount[block.type]) blockTypeWiseCount[block.type] = 0;
        blockTypeWiseCount[block.type]++;

        if (block.type == 'discount') {
          // If it's dynamic content and coupon not selected, then return false.
          if (block.content.couponInfo.dynamic) {
            // For onetime campaigns, discounted blocks are not allowed.
            if (!this.isJourneyCampaign) {
              // Show message here.
              this.$alert(`Don't use Growlytics generated coupons in one-time campaigns. Growlytics generates invidual coupons for each customers. So its better if you generate one coupon in shopify and use that one coupon for all customers. For more details, reachout to Growlytics support team.`, 'Auto-generated Coupons Not Allowed', {
                confirmButtonText: 'OK',
                callback: () => {
                  component.onBlockSelect(block, block);
                }
              });
              return false;
            }

            // If dynamic coupon not selected.
            if (!block.content.couponInfo.id) {
              // Show message here.
              this.$alert('Please select coupon to show in coupon block.', 'Coupon Not Selected', {
                confirmButtonText: 'OK',
                callback: () => {
                  component.onBlockSelect(block, block);
                }
              });
              return false;
            }
          }
        }
      }

      // Allow max 2 product list block.
      if (blockTypeWiseCount['discount'] && blockTypeWiseCount['discount'] > 2) {
        this.$alert('It looks like you have added 2+ discount blocks. Maximum 2 discount blocks can be used in email.', 'Maximum 2 discount blocks allowed', {
          confirmButtonText: 'OK'
        });
        return false;
      }

      // Only 2 Discount block is allowed.
      else if (blockTypeWiseCount['product'] && blockTypeWiseCount['product'] > 2) {
        this.$alert('It looks like you have added 2+ product list blocks. Maximum 2 product list blocks can be used in email.', 'Maximum 2 product list blocks allowed', {
          confirmButtonText: 'OK'
        });
        return false;
      }

      return true;
    },

    prepareHtmlFontStyle() {
      // Build css from mail options.
      let mailOptionsCss = ``;
      let populateCustomFonts = [];
      for (let element in this.mailOptions.textStyle) {
        let elementTextStyle = this.mailOptions.textStyle[element];

        let elementStyleList = [];
        for (let elementStyle in elementTextStyle) {
          if (elementTextStyle[elementStyle] == null) continue;

          if (elementStyle == 'textColor') {
            elementStyleList.push(`color: ${elementTextStyle[elementStyle]}`);
          } else if (elementStyle == 'alignment') {
            elementStyleList.push(`text-align: ${elementTextStyle[elementStyle]}`);
          } else if (elementStyle == 'fontFamily') {
            let fontFamilyInfo = elementTextStyle[elementStyle];
            let fontFamilyValue = '';
            if (typeof fontFamilyInfo != 'string') {
              if (fontFamilyInfo.isCustomFont) {
                populateCustomFonts.push(fontFamilyInfo.value);
                fontFamilyValue = `'${fontFamilyInfo.value.name}', ${fontFamilyInfo.value.fallback}`;
              } else {
                // Its Web Font
                fontFamilyValue = fontFamilyInfo.value;
              }
            } else {
              // Handle older logic.
              let fontFamilyObj = _.find(this.emailWebFonts, (font) => {
                return font.label == elementTextStyle[elementStyle];
              });
              fontFamilyValue = fontFamilyObj ? fontFamilyObj.value : fontFamilyInfo;
            }
            elementStyleList.push(`font-family: ${fontFamilyValue}`);
          } else if (elementStyle == 'fontSize') {
            elementStyleList.push(`font-size: ${elementTextStyle[elementStyle]}px`);
          } else if (elementStyle == 'fontWeight') {
            elementStyleList.push(`font-weight: ${elementTextStyle[elementStyle]}`);
          } else if (elementStyle == 'lineHeight') {
            elementStyleList.push(`line-height: ${elementTextStyle[elementStyle]}%`);
          } else if (elementStyle == 'letterSpacing') {
            elementStyleList.push(`letter-spacing: ${elementTextStyle[elementStyle]}px`);
          } else if (elementStyle == 'marginBottom') {
            elementStyleList.push(`margin-bottom: ${elementTextStyle[elementStyle]}px`);
          }
        }

        let output = elementStyleList.join('; ');
        if (output && !output.endsWith('; ')) output += '; ';
        mailOptionsCss += `${elementTextStyle.selector}{${output}} `;
      }

      this.mailOptions.textStyleOutput = `<style type="text/css">${mailOptionsCss}</style>`;

      // Put style for preview.
      let styleElementId = 'grw-email-builder-general-styles';
      let styleElement = document.getElementById(styleElementId);
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = styleElementId;
        document.head.appendChild(styleElement);
      }
      styleElement.innerHTML = `${mailOptionsCss}`;
      // console.log('set style =>', styleElement.innerHTML);

      // Add Custom Fonts If Mentioned.
      // for (let i = 0; i < populateCustomFonts.length; i++) {
      if (this.customFontsList.length > 0) {
        let customFontCss = '';
        for (let i = 0; i < this.customFontsList.length; i++) {
          customFontCss = this.populateStyleForCustomFonts(this.customFontsList[i]) + ' ' + customFontCss;
        }
        this.mailOptions.textStyleOutput += ` <style type="text/css"> ${customFontCss} </style> `;
      }
    },

    populateStyleForCustomFonts(customFontObj) {
      if (customFontObj.type == 'upload') {
        let fontFaceList = [];
        for (let i = 0; i < customFontObj.files.length; i++) {
          let variant = customFontObj.files[i];
          fontFaceList.push(`@font-face {
            font-family: '${customFontObj.name}';
            src: url(${variant.url}) format('${variant.format}');
            ${variant.weight ? `font-weight: ${variant.weight};` : ''}
            ${variant.style ? `font-style: ${variant.style};` : ''}
            ${variant.fontDisplay ? `font-display: ${variant.fontDisplay};` : ''}
          }`);
        }
        return fontFaceList.join('  ');
      } else {
        return ``;
      }
    },

    prepareHtml(previewText, isForPreview) {
      // Read Email Width
      let maxEmailWidth = '750px';
      if (this.mailOptions.widthInfo.type == 'custom') {
        maxEmailWidth = this.mailOptions.widthInfo.width + 'px';
      }

      // Add Dynamic Content.
      var s = new XMLSerializer();
      var urlDecodeRegex = /<a(.*?)href="(.*?)"/g;
      let blockHtml = '';
      let considerCartCss = null,
        considerProductSetCss = null,
        considerSingleProductCss = null;
      for (let i = 0; i < this.blockList.length; i++) {
        let block = this.blockList[i];

        if (block.type == 'button') {
          let refId = 'block-' + block.id;
          let component = this.$refs[refId].length ? this.$refs[refId][0] : this.$refs[refId];
          let html = component.prepareHtml();
          // Add block string to main html.
          blockHtml += html;
        } else {
          let blockElement = document.getElementById('block_' + this.blockList[i].id);
          blockElement = blockElement.cloneNode(true);

          // Remove To Be Removed elements.
          let elementsToRemove = blockElement.getElementsByClassName('to-be-removed');
          while (elementsToRemove.length > 0) {
            for (let j = 0; j < elementsToRemove.length; j++) {
              elementsToRemove[j].remove();
            }
            elementsToRemove = blockElement.getElementsByClassName('to-be-removed');
          }

          // Set Device Visiblity
          if (block.content.deviceVisiblity == 'desktop') {
            blockElement.classList.add('hide-on-mobile');
          } else if (block.content.deviceVisiblity == 'mobile') {
            blockElement.classList.add('hide-on-desktop');
          }

          // If Row block - Check if devide for mobile is disabled.
          if (block.type.startsWith('columns-')) {
            // Disable mobile responsiveness for columns.
            if (!block.content.dontKeepMobileResponsive) {
              blockElement.classList.add('mobile-responsive-columns');
            }
          }

          // For image, remove attached javascript to load failure link.
          let imageList = blockElement.getElementsByTagName('img');
          for (let j = 0; j < imageList.length; j++) {
            if (imageList[j].classList.contains('imgRender')) {
              imageList[j].setAttribute('src', imageList[j].getAttribute('mailsrc'));
              imageList[j].removeAttribute('mailsrc');
            }
          }

          // If generating content for preview, product set info from mail.
          if (isForPreview) {
            // Remove product set info.
            let productSetInfoList = blockElement.getElementsByClassName('productSetInfo');
            for (let j = 0; j < productSetInfoList.length; j++) {
              productSetInfoList[j].remove();
            }

            let singleProductInfoList = blockElement.getElementsByClassName('singleProductInfo');
            for (let j = 0; j < singleProductInfoList.length; j++) {
              singleProductInfoList[j].remove();
            }
          }

          // Stringify Block - HREF urls to be Html Decoded first.
          let blockString = s.serializeToString(blockElement);
          let match = null;
          let strToReplace = [];
          while ((match = urlDecodeRegex.exec(blockString))) {
            let originalUrl = match[2];
            //Decode url
            var elem = document.createElement('textarea');
            elem.innerHTML = originalUrl;
            originalUrl = elem.value;
            strToReplace.push({
              find: match[0],
              replace: `<a ${match[1]} href="${decodeURI(originalUrl)}"`
            });
          }
          for (let i = 0; i < strToReplace.length; i++) {
            blockString = blockString.replace(strToReplace[i].find, strToReplace[i].replace);
          }

          // Remove aditional, nuance
          blockString = blockString.replace(/<!---->/g, '');
          blockString = blockString.replace(/xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');

          // Add block string to main html.
          blockHtml += blockString;
        }

        // Check for css addition of cart or product set.
        if (this.blockList[i].type == 'product') {
          considerProductSetCss = true;
        } else if (this.blockList[i].type == 'single-product' || this.blockList[i].type == 'product-review') {
          considerSingleProductCss = true;
        } else if (this.blockList[i].type == 'cart') {
          considerCartCss = true;
        }
      }

      // Generate Html
      let html = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "https://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
        <html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
        <head>
          <meta http–equiv="Content-Type" content="text/html; charset=UTF-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
          <meta name="viewport" content="width=device-width, initial-scale=1">      
          <meta name="format-detection" content="telephone=no">
          <meta name="format-detection" content="date=no">
          <meta name="format-detection" content="address=no">
          <meta name="format-detection" content="email=no">
          ${commonCss}
          ${considerCartCss ? cartCss : ''}
          ${considerProductSetCss ? productSetCss : ''}
          ${considerSingleProductCss ? singleProductCss : ''}
          ${this.mailOptions.textStyleOutput ? this.mailOptions.textStyleOutput : ''}
        </head>

        <body><div class="mailBody" style="background-color: ${this.mailOptions.background}; height: 100% !important; 
                    width: 100% !important; font-weight: 400; font-style: normal; line-height: 1.5; font-size: 16px; 
                    overflow-wrap: break-word; word-wrap: break-word; -ms-text-size-adjust: 100%; 
                    -webkit-text-size-adjust: 100%; margin: 0 auto; padding: 0;" class="full-wrap;
                    mso-line-height-rule:exactly; word-break:break-word;" width="100%">`;

      // Add Preview Text If Provided
      if (previewText && previewText.trim()) {
        html += `<div class="litmus-builder-preview-text" style="display:none;font-size:1px;color:#333333;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">${previewText}	&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;</div>`;
      }

      // Put Main table to get started.
      html += `<center> <table class="mailContent" width="100%" cellpadding="0" cellspacing="0" style="margin-right: auto !important; margin-left: auto !important; border-spacing: 0; border-collapse: collapse; width: 100%; max-width: ${maxEmailWidth};"><tr>
        <td style="padding: 0px !important;">${blockHtml}</td></tr></table></center></div></body></html>`;

      console.log('Generted html is', html);
      return html;
    },

    getProcessedContents(previewText, isForPreview) {
      return {
        json: {
          options: this.mailOptions,
          rows: this.blockList
        },
        html: this.prepareHtml(previewText, isForPreview)
      };
    },

    async renderContent(contentJson) {
      this.prepareHtmlFontStyle();

      if (!contentJson) return;

      this.selectedBlock = null;

      this.blockList = [];
      let originalBlockList = this.$refs.blockSelector.blocks;
      for (let i = 0; i < contentJson.rows.length; i++) {
        let modifiedBlock = contentJson.rows[i];

        // REad original block.
        let originalBlock = null;
        _.forEach(originalBlockList, (categoryBlockList) => {
          let dd = _.find(categoryBlockList, (origBlock) => {
            return origBlock.type == modifiedBlock.type;
          });
          if (dd) originalBlock = dd;
        });
        if (!originalBlock) originalBlock = {};
        else originalBlock = JSON.parse(JSON.stringify(originalBlock));
        let mergedBlock = this.overrideJson(originalBlock, modifiedBlock);

        // Older email blocks - replace rowPadding With Margin
        mergedBlock = this.checkForRemovingRowPaddingFromOlderDivs(mergedBlock);

        this.blockList.push(mergedBlock);
      }

      if (contentJson.options) {
        if (contentJson.options && contentJson.options.textStyle && contentJson.options.textStyle.text) {
          contentJson.options.textStyle.text.selector = '.mailBody .blockSection';
        }
        this.mailOptions = this.overrideJson(this.mailOptions, contentJson.options);
      }
      // console.log('processed mail contents =>', this.mailOptions);

      // Render Fonts & General Email Settings.
      this.prepareHtmlFontStyle();

      // Read Brand Info As Well For currency and other details.
      if (!this.brandInfo) {
        let brandInfo = await companyModule.getCompanyMetadata();
        this.brandInfo = brandInfo.data;
      }
    },

    checkForRemovingRowPaddingFromOlderDivs(block) {
      if (!block || !block.type) return block;

      if (block.type.startsWith('columns')) {
        delete block.content.rowPadding;
        for (let i = 0; i < block.content.columns.length; i++) {
          let subBlockList = block.content.columns[i];
          for (let j = 0; j < subBlockList.length; j++) {
            let subBlock = subBlockList[j];
            subBlockList[j] = this.checkForRemovingRowPaddingFromOlderDivs(subBlock);
          }
        }
      }

      if (['email-header', 'email-footer', 'divider', 'social-icons'].indexOf(block.type) >= 0) {
        if (block.content.version === undefined && block.content.rowPadding) {
          block.content.margin = JSON.parse(JSON.stringify(block.content.rowPadding));
          delete block.content.rowPadding;
        }
      }

      return block;
    },

    //#endregion ----------- End: Parent Communication Methods---------------

    async fetchCustomFonts() {
      // Read custom fonts as well.
      let response = await companyModule.getCompanySettingByKey('custom-fonts');
      let fontData = response.data ? response.data : null;
      if (fontData) {
        this.customFontsList = JSON.parse(fontData);
        fontData = JSON.parse(fontData);
        for (let i = 0; i < fontData.length; i++) {
          let font = fontData[i];
          let fontUrl = font.files[0].url;
          const myFont = new FontFace(font.name, `url(${fontUrl})`);
          await myFont.load();
          document.fonts.add(myFont);
        }
      }
    }
  },

  mounted() {
    this.fetchCustomFonts();
  }
};

let commonCss = `
<style type="text/css">
  .mailBody table {border-spacing: 0;border-collapse: collapse;height: auto;border: none;}.mailBody a {text-decoration: none;}.mailBody .ExternalClass, .mailBody .ExternalClass p, .mailBody .ExternalClass span, .mailBody .ExternalClass td, .mailBody .ExternalClass div {line-height: 100%;}.mailBody a[x-apple-data-detectors] {color: inherit !important;text-decoration: none !important;font-size: inherit !important;font-family: inherit !important;font-weight: inherit !important;line-height: inherit !important;}.mailBody a, .mailBody a:hover {text-decoration: none;}.mailBody .blockSection {overflow: hidden;}.mailBody .blockSection .bock-image-background {background-size: cover;background-position: center;}.mailBody p {margin: 0px;white-space: pre-wrap;}.mailBody h1, .mailBody h2, .mailBody h3 {margin-block-start: 0.33em !important;margin-block-end: 0.1em !important;margin-inline-start: 0px !important;margin-inline-end: 0px !important;}.mailBody .gridSection .columnsBlock {table-layout: fixed;width: 100%;}.mailBody .gridSection .columnsBlock .section-column {overflow: hidden;}.mailBody .gridSection .columnsBlock .section-row {width: 100%;}.mailBody .gridSection .section-column-row {position: relative;}.mailBody .imagePreview {width: 100%;padding: 10px;text-align: center;}.mailBody .imagePreview i {align-self: center;font-size: 120px;color: #eaeaea;display: block;}.mailBody .imagePreview .noImgDescription {display: block;width: 100%;margin-top: 3px;color: #bbb;font-size: 13px;}.mailBody .mailFooterBlock .mail-footer-3 .mailFooterLeftSide {padding-left: 20px;}@media only screen and (min-width: 600px) {.mailBody .hide-on-desktop {display: none !important;}}@media only screen and (max-width: 600px) {.mailBody .hide-on-mobile {display: none !important;}.mailBody .mobile-responsive-columns .columnsBlock .section-column {width: 100% !important;display: block;}.mailBody .mailHeaderBlock .mailHeadeLogo {width: 100% !important;display: block;}.mailBody .mailHeaderBlock .mail-header-1 tr, .mailBody .mailHeaderBlock .mail-header-1 td {display: block;}.mailBody .mailHeaderBlock .mail-header-1 .mailHeaderLinks {width: 100% !important;text-align: center !important;padding: 0px !important;}.mailBody .mailFooterBlock .mail-footer-3 .mailFooterLeftSide {padding-left: 0px !important;}.mailBody .mailFooterBlock .mail-footer-3 td {width: 100%;display: block;text-align: center !important;}.mailBody .mailFooterBlock .mail-footer-3 td div, .mailBody .mailFooterBlock .mail-footer-3 td p, .mailBody .mailFooterBlock .mail-footer-3 td span {text-align: center !important;}}
</style>
`;

let cartCss = `
<style type="text/css">
  @media only screen and (max-width: 480px) {.cartSection .cartTable .cartItem td {width: 100% !important;max-width: 100% !important;display: block;}.cartSection .cartTable .cartItem .cartItemName {font-size: 16px !important;line-height: 20px !important;margin-bottom: 0px !important;text-align: center;width: 100%;}.cartSection .cartTable .cartItem .productInfo {text-align: center;width: 100%;font-size: 14px !important;line-height: 20px !important;}.cartSection .cartTable .cartItem .productNotes {text-align: center;font-size: 12px;line-height: 20px;color: #8a8989;}.cartSection .cartTable .cartItem .remove-in-mobile {display: none !important;}}
</style>
`;

let productSetCss = `
<style type="text/css">
.productSetsSection {overflow: hidden;width: 100%;}.productSetsSection .productSetTable {table-layout: fixed;width: 100%;}.productSetsSection .productSetTable .product-col {padding: 0px 5px;}@media only screen and (max-width: 480px) {.productSetsSection .productSetTable {width: 100% !important;max-width: 100% !important;margin: auto;}.productSetsSection .productSetTable .product-col {width: 90% !important;max-width: 90% !important;margin: auto;margin-bottom: 20px;display: block !important;}.productSetsSection .productSetTable .product-col .prodImg {width: 90% !important;height: auto !important;margin: auto !important;}.productSetsSection .productSetTable .product-col .prodName {font-size: 16px !important;margin-bottom: 0px !important;}}
</style>
`;

let singleProductCss = `
<style type="text/css">
.singleProductSection {overflow: hidden;width: 100%;}.singleProductSection .productInfoTable {table-layout: fixed;width: 100%;}.singleProductSection .productInfoTable .product-col {padding: 0px 5px;}@media only screen and (max-width: 480px) {.singleProductSection .productInfoTable {width: 90% !important;max-width: 80% !important;margin: auto;}.singleProductSection .productInfoTable .product-row-gap {display: none;}.singleProductSection .productInfoTable .product-col {width: 100% !important;max-width: 100% !important;margin-bottom: 20px;display: block !important;}.singleProductSection .productInfoTable .product-col .prodName {font-size: 16px !important;margin-bottom: 0px !important;}}
</style>
`;
